import styled, { css } from 'styled-components';
import { pxToRems } from '@awaze/design-system.utils.react';
const isBackgroundApplied = (backgroundColour) => backgroundColour !== 'transparent';
const handleSize = (size, backgroundApplied = false) => {
    switch (size) {
        case 'xs':
        case 'x-small':
            return pxToRems(backgroundApplied ? 24 : 12);
        case 's':
        case 'small':
            return pxToRems(backgroundApplied ? 32 : 16);
        case 'm':
        case 'medium':
            return pxToRems(backgroundApplied ? 40 : 20);
        case 'xl':
        case 'x-large':
            return pxToRems(48);
        case '2xl':
        case 'xx-large':
            return pxToRems(backgroundApplied ? 64 : 32);
        case '3xl':
        case 'xxx-large':
            return pxToRems(backgroundApplied ? 80 : 40);
        default:
            return pxToRems(backgroundApplied ? 48 : 24);
    }
};
export const IconWrapper = styled.div `
  display: inline-flex;
`;
export const IconContainer = styled.div `
  display: inline-block;
  width: ${({ size }) => handleSize(size, false)};
  min-width: ${({ size }) => handleSize(size, false)};
  height: ${({ size }) => handleSize(size, false)};
  min-height: ${({ size }) => handleSize(size, false)};

  > ${IconWrapper} {
    position: relative;

    display: block;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    overflow: hidden;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    display: inline-block;
    width: 100%;
    height: 100%;

    fill: ${({ iconColour, theme }) => theme[iconColour]};
  }

  ${({ backgroundColour, theme, size }) => isBackgroundApplied(backgroundColour) &&
    css `
      width: ${handleSize(size, true)};
      min-width: ${handleSize(size, true)};
      height: ${handleSize(size, true)};
      min-height: ${handleSize(size, true)};
      border-radius: 50%;

      background: ${theme[backgroundColour]};

      svg {
        width: 50%;
        height: 50%;
      }
    `}
`;
//# sourceMappingURL=icon.styles.js.map